import PaymentValidated from './PaymentValidated.container';

export default PaymentValidated;
